/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_EndInputs */

const en_us2_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End session`)
};

const pt_br2_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar treino`)
};

const es_419_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar entrenamiento`)
};

const pt_pt2_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar treino`)
};

const fr_fr2_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer la séance`)
};

const de_de2_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit beenden`)
};

const it_it2_session_end = /** @type {(inputs: Session_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina sessione`)
};

/**
* | output |
* | --- |
* | "End session" |
*
* @param {Session_EndInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const session_end = /** @type {((inputs?: Session_EndInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_EndInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_session_end(inputs)
	if (locale === "es-419") return es_419_session_end(inputs)
	if (locale === "pt-PT") return pt_pt2_session_end(inputs)
	if (locale === "fr-FR") return fr_fr2_session_end(inputs)
	if (locale === "de-DE") return de_de2_session_end(inputs)
	if (locale === "it-IT") return it_it2_session_end(inputs)
	return en_us2_session_end(inputs)
});
export { session_end as "session.end" }